/**
 * True while an input method editor is mid-composition — the keydown belongs to
 * the IME, not to the field. A Japanese user presses Enter to accept the kanji
 * candidate for what they typed in kana; that keydown carries `key === 'Enter'`
 * like any other, so an Enter-to-submit handler that doesn't ask this sends the
 * half-converted text.
 *
 * `isComposing` covers Chrome and Firefox. Safari fires the confirming keydown
 * AFTER `compositionend`, with `isComposing` already false — its tell is the
 * legacy `keyCode` 229 ("IME is processing this key").
 */
export function isImeComposing(event: { nativeEvent: KeyboardEvent } | KeyboardEvent): boolean {
  const native = 'nativeEvent' in event ? event.nativeEvent : event;
  return native.isComposing || native.keyCode === 229;
}
